"use strict";
var address_valid_state_enum_1 = require("./address-valid-state.enum");
var AddressSearchResult = (function () {
    function AddressSearchResult(postalCode, stateIso2Code, city, country, address1, address2) {
        this.result = {
            postalCode: postalCode,
            stateOrProvince: stateIso2Code,
            city: city,
            address1: address1,
            address2: address2,
            country: country || 'US',
            stateName: null,
            olsonTimeZone: null,
            timeZoneAccuracy: null
        };
        this.validState = address_valid_state_enum_1.AddressValidState.Unverified;
    }
    return AddressSearchResult;
}());
exports.AddressSearchResult = AddressSearchResult;
//# sourceMappingURL=D:/a/1/s/eligibility/src/models/jurisdictions/address-search-result.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/models/jurisdictions/address-search-result.model.js